import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import Index from '../views/index.vue'
import Answer from '../views/answer.vue'
import AnswerEnd from '../views/answerEnd.vue'
import Result from '../views/result.vue'
import CanvasGenerate from '../views/canvasGenerate.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/home',
    name: 'Home',
    component: Home
  },
  {
    path: '/index',
    name: 'Index',
    component: Index
  },
  {
    path: '/answer',
    name: 'Answer',
    component: Answer
  },
  {
    path: '/answerEnd',
    name: 'AnswerEnd',
    component: AnswerEnd
  },
  {
    path: '/result',
    name: 'Result',
    component: Result
  },
  {
    path: '/canvasGenerate',
    name: 'CanvasGenerate',
    component: CanvasGenerate
  },
]

const router = new VueRouter({
  routes
})

export default router
